'use strict'

const isPro = Object.is(process.env.NODE_ENV, 'production')
const uinfo = navigator.userAgent
new RegExp(`MSIE (\\d+\\.\\d+);`).test(uinfo)
export default {
  name: 'Ylfund',
  version: '0.0.1',
  date: '2025-07-04',
  protocol: 'https',
  // host: window.location.host,
  // hostname: window.location.hostname,
  // url: `http://${window.location.host}/api`,
  // imageurl: isPro ? `https://${window.location.host}` : `/static`,
  // // imageurl: isPro ? `https://${window.location.host}` : `http://www.yticap.com`,
  // // tokenurl: `http://${window.location.host}/index.php/get_new_token`,
  // website: `http://${window.location.host}`,
  // domain: window.location.host,
  // origin: window.location.origin,
  userAgent: uinfo,
  isWx: uinfo.indexOf('MicroMessenger') > -1,
  isOpera: uinfo.indexOf('Opera') > -1,
  isFireFox: uinfo.indexOf('Opera') < 0 && uinfo.indexOf('Firefox') > -1,
  isChrome: uinfo.indexOf('Opera') < 0 && uinfo.indexOf('Firefox') < 0 && uinfo.indexOf('Chrome') > -1,
  isSafari: uinfo.indexOf('Opera') < 0 && uinfo.indexOf('Firefox') < 0 && uinfo.indexOf('Chrome') < 0 && uinfo.indexOf('Safari') > -1,
  // isIe: uinfo.indexOf('compatible') > -1 && uinfo.indexOf('MSIE') > -1 && uinfo.indexOf('Opera') < 0,
  isIe: uinfo.indexOf('Trident') > -1,
  isIe11: uinfo.indexOf('Trident') > -1 && uinfo.indexOf('rv:11.0') > -1,
  isIe11cp: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) === 11,
  isIe10: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) === 10,
  isIe9: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) === 9,
  isIe8: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) === 8,
  isIe7: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) === 7,
  isIe6: uinfo.indexOf('Trident') > -1 && parseFloat(RegExp['$1']) < 7,
  isEdge: uinfo.indexOf('Edge') > -1,
  trident: uinfo.indexOf('Trident') > -1, // IE内核
  presto: uinfo.indexOf('Presto') > -1, // opera内核
  webKit: uinfo.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
  gecko: uinfo.indexOf('Firefox') > -1, // 火狐内核Gecko
  isMobile: !!uinfo.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
  isIos: !!uinfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios
  isAndroid: uinfo.indexOf('Android') > -1 || uinfo.indexOf('Linux') > -1, // android
  iPhone: uinfo.indexOf('iPhone') > -1, // iPhone
  iPad: uinfo.indexOf('iPad') > -1 // iPad
  // apiprefix: 'api',
  // apiversion: '1.0',
  // demoImg: '/static/images/tm.gray.png',
  // mobilmenufontzoom: 0.8,
  // mobiltitlefontzoom: 1.9,
  // mobilcontentfontzoom: 1.5,
  // // mobilbottomcontentfontzoom: 0.8,
  // mobilbtnfontzoom: 1.9
}
